module.exports = __webpack_public_path__ + "img/header_logo.7afad689.svg";